{
  "feedback-internal-details-page": {
    "buttons": {
      "submit": "SOUMETTRE"
    },
    "text": {
      "comment": "Votre commentaire",
      "cleanliness": "Ambiance et propreté",
      "hint": "Aidez-nous à savoir ce que vous pensez de notre service",
      "service": "Service",
      "staff": "Personnel"
    }
  }
}
